exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_navigationBarContentWrapper_7K557mBpAChNyTpSAyJHv {\n  display: flex;\n  height: 100%;\n  flex-direction: row-reverse;\n  align-Items: center;\n}\n\n.IA_templateEditorWrapper_2LXN6a5IkBqQNYLI-cqofn {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n.IA_createTemplateButtonWrapper_WtM8MZtDn4xVNMVN26LMK {\n  margin-top: 25px;\n}", ""]);

// Exports
exports.locals = {
	"IA_navigationBarContentWrapper": "IA_navigationBarContentWrapper_7K557mBpAChNyTpSAyJHv",
	"IA_templateEditorWrapper": "IA_templateEditorWrapper_2LXN6a5IkBqQNYLI-cqofn",
	"IA_createTemplateButtonWrapper": "IA_createTemplateButtonWrapper_WtM8MZtDn4xVNMVN26LMK"
};